import { Stack } from "@mui/material";
import { Container } from "@mui/system";
import { useEffect, useState } from "react";
import ProductAutocomplete from "../components/input/ProductAutocomplete";
import ScoreSortSelect from "../components/input/ScoreSortSelect";
import PrivilegedInformationHeader from "../components/PrivilegedInformationHeader";
import ScoreCard from "../components/ScoreCard";
import { useProductApi, ProductMetadata } from "../hooks/ProductApiHook";
import FiltersMenu from "../components/input/FiltersMenu";
import { useMemo } from "react";

const Home: React.FC = () => {
  const productApi = useProductApi();
  let [products, setProducts] = useState<Array<ProductMetadata>>([]);
  let [scoreSortingValue, setScoreSortingValue] = useState<0 | 1 | 2>(0);
  let [searchValue, setSearchValue] = useState<string>("");
  let [selectedTags, setSelectedTags] = useState<string[]>([]);

  const tagOptions: string[] = useMemo(() => {
    const names = new Set<string>();
    for (const p of products || []) {
      for (const a of p.attributes || []) {
        if (a?.name) names.add(a.name);
      }
    }
    return Array.from(names).sort((a, b) => a.localeCompare(b));
  }, [products]);

  const getProducts = async () => {
    try {
      let data = await productApi.GetAllProductsMetadata();
      setProducts(data);
    } catch (e) {
    }
  }

  useEffect(() => {
    getProducts();
  }, []);

  // After products load, scroll to the last clicked product card if stored
  useEffect(() => {
    const STORAGE_KEY = "homeScrollToProductId";
    if (!products || products.length === 0) return;
    try {
      const id = localStorage.getItem(STORAGE_KEY);
      if (!id) return;
      requestAnimationFrame(() => {
        const el = document.getElementById(`product-${id}`);
        if (el) {
          const appBar = document.querySelector('header.MuiAppBar-root') as HTMLElement | null;
          const headerHeight = appBar?.offsetHeight ?? 64;
          const padding = 8;
          const y = el.getBoundingClientRect().top + window.pageYOffset - headerHeight - padding;
          window.scrollTo({ top: y, behavior: 'auto' });
        }
        localStorage.removeItem(STORAGE_KEY);
      });
    } catch {
    }
  }, [products]);

  return (
    <Container>
      <Stack spacing={2}>
        <PrivilegedInformationHeader />
        <Stack spacing={2} direction="row">
          <ProductAutocomplete
            products={products}
            value={searchValue}
            setValue={setSearchValue}
          />

          <ScoreSortSelect
            setSortingValue={setScoreSortingValue}
          />
          <FiltersMenu options={tagOptions} value={selectedTags} onChange={setSelectedTags} />
        </Stack>
        <Stack spacing={2}>
          {products.filter((product) => {
            if (product.scores != null) {
              return product;
            }
          }).filter((product) => {
            if (searchValue == "") {
              return product;
            }
            if (product.name.includes(searchValue)) {
              return product;
            }
          }).filter((product) => {
            if (!selectedTags || selectedTags.length === 0) return product;
            const attrs = product.attributes || [];
            const hasAll = selectedTags.every(tagName =>
              attrs.some(a => a.name === tagName)
            );
            if (hasAll) return product;
          }).sort((a, b) => {
            if (scoreSortingValue == 1) {
              return b.totalScore - a.totalScore;
            } else if (scoreSortingValue == 2) {
              return a.totalScore - b.totalScore;
            }
            return a.name.localeCompare(b.name);
          }).map((product) => (

            <ScoreCard
              product={product}
              key={product.id}
            />
          ))}

        </Stack>
      </Stack>
    </Container>
  );
}

export default Home; 
